import React from 'react';
import PropTypes from 'prop-types';

import { InputContainer } from './style';

export const Input = ({ labelComponent, labelMessage, errorComponent, errorMessage, inputComponent, ...props }) => {
    const InputComponent = inputComponent;
    const ErrorComponent = errorComponent;
    const LabelComponent = labelComponent;

    return (
        <InputContainer>
            {labelMessage && labelComponent && <LabelComponent>{labelMessage}</LabelComponent>}
            <InputComponent {...props} />
            {errorMessage && errorComponent && <ErrorComponent>{errorMessage}</ErrorComponent>}
        </InputContainer>
    );
};

Input.defaultProps = {
    inputComponent: () => {},
    onChange: () => {},
    placeholder: '',
    value: '',
    name: '',
};

Input.propTypes = {
    inputComponent: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,

    labelComponent: PropTypes.func,
    labelMessage: PropTypes.string,
    errorComponent: PropTypes.func,
    errorMessage: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/UI/Components/Input/index.js